/**
 * Nederlandse wandkloktijd via de échte Europe/Amsterdam-tijdzone.
 *
 * Vervangt de oude "UTC+1"-benadering die in de zomer (CEST = UTC+2) een uur
 * achterliep — waardoor bijv. om 16:45 de cutoff van 16:00 nog niet bereikt
 * leek. Client-safe (geen server-only imports).
 */
export interface NlTimeParts {
  /** "2026-07-07" */
  dateStr: string
  year:    number
  month:   number // 1-12
  day:     number
  hour:    number // 0-23
  minute:  number
}

export function nlTimeParts(at: Date = new Date()): NlTimeParts {
  const parts = new Intl.DateTimeFormat('nl-NL', {
    timeZone: 'Europe/Amsterdam',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hour12: false,
  }).formatToParts(at)
  const get = (t: Intl.DateTimeFormatPartTypes) => parts.find((p) => p.type === t)?.value ?? '0'
  const year   = Number(get('year'))
  const month  = Number(get('month'))
  const day    = Number(get('day'))
  const hour   = Number(get('hour')) % 24 // sommige runtimes geven "24" rond middernacht
  const minute = Number(get('minute'))
  return {
    dateStr: `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`,
    year, month, day, hour, minute,
  }
}

/** Vandaag in Nederland als "YYYY-MM-DD". */
export function todayStrNL(): string {
  return nlTimeParts().dateStr
}
